<div *ngIf="variant === 'default'" class="hub-input" [ngStyle]="customStyle" [ngClass]="{ center: fieldConfigs.center }">
    <label
        *ngIf="!fieldConfigs.hideLabel"
        [for]="id"
        class="emd-label"
        [ngClass]="{
            _state_error: control.touched && control.invalid && control.dirty,
        }"
        >{{ label }}<i *ngIf="isRequired"> *</i></label
    >
    <input
        #formInput
        [id]="id"
        class="emd-input"
        type="text"
        [ngStyle]="customStyle"
        [ngClass]="{
            _state_error: control.invalid && (control.touched || control.dirty),
            _state_success: successFeedback,
        }"
        [placeholder]="fieldConfigs.placeholder"
        currencyMask
        [options]="fieldConfigs.currencyOptions"
        [disabled]="isReadOnly"
        [(ngModel)]="value"
        [min]="0"
        (input)="onChanged(value)"
        (blur)="onTouched()"
        [attr.data-cy]="controlName"
    />
    <app-control-error [control]="control" [label]="label" [hideLabel]="fieldConfigs.hideLabel"></app-control-error>
</div>

<div
    *ngIf="variant === 'inline'"
    class="hub-input eu-display_flex eu-align-items_center"
    style="gap: 1.25rem"
    [ngStyle]="customStyle"
    [ngClass]="{ center: fieldConfigs.center }"
>
    <label
        *ngIf="!fieldConfigs.hideLabel"
        [for]="id"
        class="emd-label"
        style="min-width: fit-content"
        [ngClass]="{
            _state_error: control.touched && control.invalid && control.dirty,
        }"
        >{{ label }}<i *ngIf="isRequired"> *</i></label
    >
    <input
        #formInput
        [id]="id"
        class="emd-input"
        type="text"
        [ngStyle]="customStyle"
        [ngClass]="{
            _state_error: control.touched && control.invalid && control.dirty,
            _state_success: successFeedback,
        }"
        [placeholder]="fieldConfigs.placeholder"
        currencyMask
        [options]="fieldConfigs.currencyOptions"
        [disabled]="isReadOnly"
        [(ngModel)]="value"
        [min]="0"
        (input)="onChanged(value)"
        (blur)="onTouched()"
        [attr.data-cy]="controlName"
    />
    <app-control-error [control]="control" [label]="label" [hideLabel]="fieldConfigs.hideLabel"></app-control-error>
</div>
